import { JURISDICTION_MASTER_STATUS_KEYS } from '../../../../../../consts/jurisdictions';
import { v4 } from 'uuid';

export function mapFundsFromJuris(jurisNational, existingFunds = []) {
  return jurisNational.map(nat => {
    const old = existingFunds.find(f => f.key === nat.fund_id);

    return {
      id: nat.id,
      key: nat.fund_id,
      name: nat.fund_name,
      code: old?.code ?? nat.aif_national_code,
      isIncluded: old?.isIncluded ?? nat.is_included,
      isLastReporting: old?.isLastReporting ?? nat.last_reporting_flag ?? false,
      aifNoReportingFlag: old?.aifNoReportingFlag ?? nat.aif_no_reporting_flag,
      baseCurrency: old?.baseCurrency ?? nat.base_currency,
      masterFeederStatus: old?.masterFeederStatus ?? nat.aif_master_feeder_status ?? null,
      masterFundIds:
        old?.masterFundIds ??
        nat.master_fund_ids ??
        nat.master_funds?.map(el => el.fund_id).filter(Boolean) ??
        []
    };
  });
}

export function mapFundsFromNew(funds = [], nationalCodes = [], existingFunds = []) {
  const existingIds = nationalCodes.map(n => n.fund_id);

  return funds
    .filter(f => !existingIds.includes(f.id))
    .map(fund => {
      const old = existingFunds.find(x => x.key === fund.id);

      return {
        key: fund.id,
        id: null,
        name: fund.name,
        code: old?.code ?? '',
        isIncluded: old?.isIncluded ?? false,
        isLastReporting: old?.isLastReporting ?? false,
        aifNoReportingFlag: old?.aifNoReportingFlag ?? false,
        baseCurrency: old?.baseCurrency ?? null,
        masterFeederStatus: old?.masterFeederStatus ?? null,
        masterFundIds: old?.masterFundIds ?? []
      };
    });
}

export function mapCustomFunds(customMasterFunds = [], juris, existingFunds = []) {
  return customMasterFunds.map(cf => {
    const matchedNat = juris.national_codes.find(n => n.fund_id === cf.id);
    const old = existingFunds.find(f => f.key === cf.id);

    return {
      id: matchedNat?.aif_national_code ? matchedNat.id : (old?.id ?? null),
      key: cf.id,
      isCustomMasterFund: true,
      name: cf.fund_name,
      code: old?.code ?? matchedNat?.aif_national_code ?? '',
      isIncluded: true,
      isLastReporting: false,
      aifNoReportingFlag: false,
      baseCurrency: null,
      masterFeederStatus: JURISDICTION_MASTER_STATUS_KEYS.MASTER,
      masterFundIds: []
    };
  });
}

export function mergeCustomFundsOnly(existingFunds = [], customMasterFunds = []) {
  const existingCustomMap = new Map(
    existingFunds.filter(f => f.isCustomMasterFund).map(f => [f.key, f])
  );

  const mergedCustomFunds = customMasterFunds.map(cf => {
    const existing = existingCustomMap.get(cf.id);

    if (existing) {
      return existing; // preserve all existing values
    }

    return {
      key: cf.id,
      isCustomMasterFund: true,
      name: cf.fund_name,
      code: '',
      isIncluded: true,
      isLastReporting: false,
      aifNoReportingFlag: false,
      baseCurrency: null,
      masterFeederStatus: JURISDICTION_MASTER_STATUS_KEYS.MASTER,
      masterFundIds: []
    };
  });

  const nonCustomFunds = existingFunds.filter(f => !f.isCustomMasterFund);

  return [...mergedCustomFunds, ...nonCustomFunds];
}

export function createNewForm(juris, funds) {
  return {
    generatedId: juris.id || v4(),
    id: juris.id,
    aifm: juris.aifm_national_code,
    country: juris.reporting_member_state,
    funds
  };
}
